import { create } from "zustand"
import type { TFileModal, TDeleteConfirmModal, TChangeOwnerModal } from "types/modal.type"

export const useFileModalStore = create<TFileModal>((set) => ({
	isFileModalOpen: false,
	triggerFileModal: () => set((state) => ({ isFileModalOpen: !state.isFileModalOpen })),
	setFileModalClose: () => set(() => ({ isFileModalOpen: false })),
}))

export const useDeleteConfirmModalStore = create<TDeleteConfirmModal>((set) => ({
	isDeleteConfirmModalOpen: false,
	openDeleteConfirmModal: () => set(() => ({ isDeleteConfirmModalOpen: true })),
	setDeleteConfirmModalClose: () => set(() => ({ isDeleteConfirmModalOpen: false })),

	deleteFile: { id: 0, fileName: "" },
	setDeleteFile: (file) => set(() => ({ deleteFile: file })),
}))

// The modal is open while a file is set.
export const useChangeOwnerModalStore = create<TChangeOwnerModal>((set) => ({
	changeOwnerFile: null,
	openCount: 0,
	openChangeOwnerModal: (file) => set((state) => ({ changeOwnerFile: file, openCount: state.openCount + 1 })),
	closeChangeOwnerModal: () => set(() => ({ changeOwnerFile: null })),
}))
